module.exports = __webpack_public_path__ + "static/media/small-arrow.2921bc4d.svg";